module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/id/3-455362ce9e8877c34311228d32b3175c.jpg";